module.exports = __webpack_public_path__ + "files/e9efa92e72f7113fb15ac23a1377acc5.png";